import CmsElmWrapper from '../../CmsElmWrapper';
import renderElements from '~/helpers/renderer/renderer';
import {
  createJobDetailSlotsSpacing,
  updateSharedContentProps,
} from '../Contact.JobDetail.helpers';

/**
 * @param {SharedContentSlotProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SharedContentSlot = ({ sharedContent, slotName, className }) => {
  const slotHasContent = sharedContent?.slotContent.some(
    (t) => t.slotName === slotName && t.content.length > 0,
  );
  const slotIndex = sharedContent?.slotContent.findIndex(
    (k) => k.slotName === slotName,
  );

  if (slotHasContent) {
    return (
      <CmsElmWrapper
        id={slotName}
        spacing={createJobDetailSlotsSpacing(slotName)}
        className={className}
      >
        {renderElements(
          updateSharedContentProps(
            sharedContent?.slotContent[slotIndex]?.content,
            slotName,
          ),
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          true,
        )}
      </CmsElmWrapper>
    );
  }

  return <></>;
};

export default SharedContentSlot;
